// NPM Imports
import React from "react";

// Component Imports
import UserRoleSelectInSettingPage from "./UserRoleSelectInSettingPage";
import UserRoleSelectInSettingPageUpgrade from "./UserRoleSelectInSettingPageUpgrade";
import { FeatureGating } from "../../../../commonComponents";

// Internal Imports
import { FEATURES } from "../../../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function (props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.SYSTEM_ROLES}
      altComponent={<UserRoleSelectInSettingPageUpgrade {...props} />}>
      <UserRoleSelectInSettingPage {...props} />
    </FeatureGating>
  );
}
